<template>
  <div class="row">
    <div class="col-sm-7">
      <div class="form-group row filter-type-date">
        <div class="col-sm-3">
          <select v-model="dateOperator" :name="'filter_' + fieldKey + '[date_operator]'" class="form-control">
            <option v-for="op in Object.entries(dateOperatorOptions)" :value="op[0]">{{ op[1] }}</option>
          </select>
        </div>
        <div class="col-sm-9">

          <div v-if="dateOperator === 'relative'" class="input-group">
            <input class="form-control" v-model="start" :name="'filter_' + fieldKey + '[start]'" type="text" placeholder="Example: -30d (last 30 days)">
            <span class="input-group-addon">to</span>
            <input class="form-control" v-model="end" :name="'filter_' + fieldKey + '[end]'" type="text" placeholder="Example: 0d (today)">
          </div>

          <div v-if="dateOperator === 'absolute'" class="row">

            <div class="col-md-6">
              <datepicker
                v-model="start"
                :name="'filter_' + fieldKey + '[start]'"
                position="left"
                placeholder="Start date">
              </datepicker>
            </div>

            <div class="col-md-6">
              <datepicker
                v-model="end"
                :name="'filter_' + fieldKey + '[end]'"
                position="left"
                placeholder="End date">
              </datepicker>
            </div>

          </div>
        </div>

      </div>
    </div>

    <div class="col-sm-5">
      <vue-chosen
        v-model="status"
        :name="'filter_' + fieldKey + '[status][]'"
        :options="lists.statuses"
        :multiple="true"
        class="form-control"
        placeholder="Follow-up status ..."
      ></vue-chosen>
    </div>
  </div>
</template>

<script>
export default {

  props: {
    operator: {type: String, required: true},
    fieldKey: {type: String, required: true},
    fieldValue: {type: [String, Object], default: ''},
    statuses: {type: Object, default: function () { return {} }},
  },

  /**
   * Variables (models).
   */
  data () {
    return {
      status: this.fieldValue.status ?? '',
      start: this.fieldValue.start ?? '',
      end: this.fieldValue.end ?? '',
      dateOperator: this.fieldValue.date_operator ?? 'absolute',
      lists: {
        'statuses': this.statuses,
      },
    }
  },

  computed: {

    dateOperatorOptions() {
      return {
        'absolute': 'Abs.',
        'relative': 'Rel.',
      };
    }

  },

  watch: {
    dateOperator: {
      handler(value) {
        this.start = '';
        this.end = '';
      }
    }
  }

}
</script>
